<template>
  <div>
      <div v-if="ships" v-for="ship in ships" :key="ship.id">
        <ship v-if="ship.btbs[0]" :ship="ship.btbs[0]" :opp="opp" @click="openSection($event, ship.btbs[0].id)"/>
        <span class="row">
            <accordion shadowy="true">
                <div slot="head">
                    {{ship.name}}
                </div>
                <div slot="body" class="paragraph" v-if="ship.btbs[0]">
                    {{ship.btbs[0].description}}
                </div>
            </accordion>
        </span>
        <span class="row" v-if="ship.btbs[0]">
           <accordion subTitle="true" v-if="ships" v-for="zone in ship.btbs[0].boat.zones" :key="zone.id">
                <div slot="head" style="display: flex; pointer-events: none" :id="`${zone.code}_${ship.btbs[0].id}`">
                    <img class="point" :src="`../../static/img/${opp}/ships/${ship.btbs[0].boat.code}/${zone.code}_spot.svg`"/>
                    <span>{{zone.name}}</span>
                </div>
                <div slot="body">
                    <div v-for="(job, index) in zone.zone_jobs" :key="job.id">
                        <span class="title">{{job.name}}:</span>
                        Titulaciones: {{job.job_titles.map(x=>x.name) | listToString}}
                        <div class="separator" v-if="index != zone.zone_jobs.length - 1"/>
                    </div>
                    <span class="title" :style="{color: colors.background.end}" @click="setModalZone(zone)">+INFO</span>
                </div>
            </accordion>
        </span>
      </div>
      <modal v-if="modalZone" @close="setModalZone()">
        <h2 slot="header">
          {{modalZone.name}}
        </h2>
        <div slot="body">
          <div v-for="(job, index) in modalZone.zone_jobs" :key="job.id">
            <h3 class="title">{{job.name}}:</h3>
              <div class="justify paragraph">{{job.description}}</div>
              <h4>Titulaciones: </h4>
               <div class="justify" v-for="title in job.job_titles" :key="title.id">
                 <b>·{{title.name}}:</b>
                 <div class="paragraph">{{title.description}}</div>
               </div>
            <div class="separator" v-if="index != modalZone.zone_jobs.length - 1"/>
          </div>
        </div>
      </modal>
  </div>
</template>

<script>
import accordion from '@/components/accordion'
import Modal from '@/components/Modal'
import ship from '@/components/ship'
import axios from 'axios'
export default {
  name: 'dashboard',
  props: ['opp', 'colors'],
  components: {accordion, ship, Modal},
  mounted () {
    axios
      .get(`${process.env.API_URL}/api/opps/${this.opp.toUpperCase()}/`)
      .then(response => {
        this.ships = response.data.results || response.data
        this.ships = this.ships.boat_types
        this.$emit('loaded')
      })
      .catch(err => {
        return err
      })
  },
  data () {
    return {
      ships: undefined,
      modalZone: undefined
    }
  },
  filters: {
    listToString: function (list) {
      if (!list) return ''
      list = JSON.stringify(list)
      list = list.replace(/\[|\]|"/g, '')
      list = list.replace(/,/g, ', ')
      return list.toLowerCase() + '.'
    }
  },
  computed: {
  },
  methods: {
    openSection (zone, ship) {
      var el = document.getElementById(`${zone}_${ship}`)
      el.click()
      window.scroll(0, el.offsetTop - 30)
    },
    setModalZone (modalZone) {
      if (modalZone) {
        this.modalZone = modalZone
      } else {
        this.modalZone = undefined
      }
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/PageDashboard.vue